import { useContext } from 'react';
import {AuthenticationContext} from "../../core/contexts/authentication/authentication-context";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useAuth = () => useContext(AuthenticationContext);

export default useAuth;
